export const services = {
  hero: {
    home: 'Home',
    services: 'Services',
    title: 'Comprehensive Industrial Services',
    subtitle1: 'Expert technical consulting and support services designed to optimize your filtration processes and maximize operational efficiency',
    subtitle2: 'From initial analysis to ongoing optimization, we provide complete solutions tailored to your specific industrial requirements',
  },
  stats: {
    projectsCompleted: 'Projects Completed',
    clientSatisfaction: 'Client Satisfaction',
    technicalSupport: 'Technical Support',
    yearsExperience: 'Years Experience',
  },
  ourServices: {
    title: 'Our Services',
    subtitle: 'Complete range of professional services to support your filtration and purification needs',
    keyDeliverables: 'Key Deliverables:',
    requestService: 'Request Service',
  },
  services: {
    needsAnalysis: {
      title: 'Industrial Needs & Application Analysis',
      description: 'Comprehensive evaluation of your industrial processes, requirements, and challenges to identify optimal filtration solutions.',
      deliverable1: 'Process flow analysis',
      deliverable2: 'Requirements assessment',
      deliverable3: 'Technical feasibility study',
      deliverable4: 'Cost-benefit analysis',
      deliverable5: 'Solution recommendations',
    },
    technicalConsulting: {
      title: 'Technical Consulting in Filtration & Purification',
      description: 'Expert guidance on filtration technologies, equipment selection, and process optimization from experienced engineers.',
      deliverable1: 'Technology selection guidance',
      deliverable2: 'Equipment specifications',
      deliverable3: 'Performance optimization',
      deliverable4: 'Regulatory compliance support',
      deliverable5: 'Best practices implementation',
    },
    processOptimization: {
      title: 'Industrial Process Optimization',
      description: 'Systematic improvement of existing filtration systems and media to enhance efficiency, reduce costs, and improve product quality.',
      deliverable1: 'Performance audits',
      deliverable2: 'Efficiency improvements',
      deliverable3: 'Cost reduction strategies',
      deliverable4: 'Quality enhancement',
      deliverable5: 'Operational optimization',
    },
    equipmentIntegration: {
      title: 'Equipment Selection & Integration',
      description: 'Professional assistance in selecting and integrating the right filtration equipment for your specific applications.',
      deliverable1: 'Equipment evaluation',
      deliverable2: 'Vendor selection support',
      deliverable3: 'Integration planning',
      deliverable4: 'Installation supervision',
      deliverable5: 'Commissioning support',
    },
    customerSupport: {
      title: 'Technical Assistance & Customer Support',
      description: 'Ongoing technical support and troubleshooting to ensure optimal performance and minimize downtime.',
      deliverable1: '24/7 technical hotline',
      deliverable2: 'Remote diagnostics',
      deliverable3: 'On-site support',
      deliverable4: 'Troubleshooting assistance',
      deliverable5: 'Emergency response',
    },
    customizedSolutions: {
      title: 'Industry-Specific Customized Solutions',
      description: 'Tailored filtration solutions designed specifically for your industry requirements and operational constraints.',
      deliverable1: 'Custom system design',
      deliverable2: 'Application-specific solutions',
      deliverable3: 'Pilot testing programs',
      deliverable4: 'Scale-up support',
      deliverable5: 'Performance validation',
    },
  },
  process: {
    title: 'Our Service Process',
    subtitle: 'Structured approach to delivering exceptional results and long-term success',
    step1Title: 'Initial Consultation',
    step1Desc: 'Discuss your requirements, challenges, and objectives with our technical team',
    step2Title: 'Analysis & Assessment',
    step2Desc: 'Comprehensive evaluation of your processes and identification of optimal solutions',
    step3Title: 'Solution Design',
    step3Desc: 'Development of customized filtration system specifications and recommendations',
    step4Title: 'Implementation',
    step4Desc: 'Equipment procurement, installation, and system commissioning support',
    step5Title: 'Ongoing Support',
    step5Desc: 'Continuous technical assistance, optimization, and performance monitoring',
    readyToStart: 'Ready to start your filtration optimization journey?',
    beginProject: 'Begin Your Project',
  },
  caseStudies: {
    title: 'Success Stories',
    subtitle: 'Real-world results demonstrating our commitment to client success and technical excellence',
    challenge: 'Challenge',
    solution: 'Solution',
    results: 'Results Achieved',
    testimonial: 'Testimonial',
    case1: {
      industry: 'Food & Beverage',
      tag: 'Beverage Clarification',
      title: 'Juice Production Optimization',
      challenge: 'A major juice manufacturer faced inconsistent product clarity and high filter media consumption, resulting in increased costs and quality variations.',
      solution: 'Implemented advanced depth filtration system with optimized filter media selection and process parameters, including automated monitoring and control.',
      result1: '40% reduction in filter media costs',
      result2: '95% improvement in product clarity consistency',
      result3: '25% increase in production throughput',
      result4: 'Reduced downtime by 60%',
      testimonial: "Ste EINA Ltd's technical expertise transformed our filtration process. The results exceeded our expectations, and their ongoing support has been invaluable.",
      client: 'Production Manager, Leading Juice Manufacturer',
    },
    case2: {
      industry: 'Pharmaceutical',
      tag: 'Sterile Filtration',
      title: 'API Purification Enhancement',
      challenge: 'Pharmaceutical company required improved sterile filtration for active pharmaceutical ingredient production while maintaining GMP compliance and reducing validation time.',
      solution: 'Designed and implemented validated sterile filtration system using pharmaceutical-grade membrane technology with comprehensive documentation and testing protocols.',
      result1: '99.99% sterility assurance achieved',
      result2: '50% reduction in validation time',
      result3: 'Full GMP compliance maintained',
      result4: '30% increase in batch yield',
      testimonial: "The team's understanding of pharmaceutical requirements and regulatory standards was exceptional. They delivered a solution that met all our stringent criteria.",
      client: 'Quality Director, Pharmaceutical Manufacturer',
    },
    case3: {
      industry: 'Water Treatment',
      tag: 'Membrane Filtration',
      title: 'Municipal Water Purification',
      challenge: 'City water treatment facility needed to upgrade aging filtration infrastructure to meet new water quality standards while managing budget constraints.',
      solution: 'Implemented cost-effective membrane filtration system with modular design, allowing phased installation and integration with existing infrastructure.',
      result1: 'Water quality exceeds new standards by 20%',
      result2: '35% reduction in chemical usage',
      result3: '45% lower operating costs',
      result4: 'Extended equipment lifespan',
      testimonial: 'EINA provided a practical solution that addressed our technical and budgetary requirements. The system performance has been outstanding.',
      client: 'Chief Engineer, Municipal Water Authority',
    },
  },
};